/* eslint-disable jsx-a11y/label-has-for,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { Map, Polygon, TileLayer } from 'react-leaflet';
import L from 'leaflet';
import { GeozoneOptions } from './Options';


const enhance = compose(translate(['geozones'], { wait: true }));

const tileUrl = L.Browser.retina
  ? 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}@2x.png'
  : 'https://tiles.corp.smartdriving.io/v1/map/{z}/{x}/{y}.png';

const icon = L.divIcon({
  html: '<div class="dot-region"></div>',
});

const convertWeekdaysToState = (weekdays) =>
  ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
    .filter((day) => weekdays[day].length)
    .map(day => day.substr(0, 2));

export const GeozoneItem = enhance(({ geozone, t, onDelete, onEdit, onActivate }) => {
  const points = geozone.wkt.split('((')[1].split('))')[0].split(',').map((item) => {
    const trimmed = item.trim();
    return {
      lat: parseFloat(trimmed.split(' ')[1]),
      lng: parseFloat(trimmed.split(' ')[0]),
    };
  });
  points.splice(points.length - 1, 1);

  const rightPosition = points.reduce((prev = { lng: Number.MIN_VALUE, lat: Number.MAX_VALUE }, curr) => {
    const currPosition = { ...prev };
    currPosition.lat = Math.max(prev.lat, curr.lat);
    currPosition.lng = Math.max(prev.lng, curr.lng);
    return currPosition;
  });
  const leftPosition = points.reduce((prev = { lng: Number.MIN_VALUE, lat: Number.MAX_VALUE }, curr) => {
    const currPosition = { ...prev };
    currPosition.lat = Math.min(prev.lat, curr.lat);
    currPosition.lng = Math.min(prev.lng, curr.lng);
    return currPosition;
  });

  const days = convertWeekdaysToState(geozone.weekly || {});
  const position = [(leftPosition.lat + rightPosition.lat) / 2, (leftPosition.lng + rightPosition.lng) / 2];
  const enabled = geozone.isEnabled;

  return (<div className="garage-section">
    <div className={cn('garage-section__content', { translucent: geozone.deleting })}>
      <div className="garage-section__description">
        <h3 className="garage-section__title_link" onClick={onEdit}>{geozone.name}</h3>
        <div className="garage-section__text">
          {days.map(day => t(`geozones:${day}`)).join(',')}
        </div>
      </div>
      <footer className="garage-section__footer">
        <label className="switch">
          <input type="checkbox" checked={enabled} onChange={onActivate} />
          <span className="slider" />
          <span className="switch__text" style={{ top: 0 }} data-on-text={t('geozones:active')} data-off-text={t('geozones:non-active')} />
        </label>
        <GeozoneOptions editText={t('common:edit')} removeText={t('common:remove')} handleEdit={onEdit} handleRemove={onDelete} />
      </footer>
    </div>
    <div className={cn('garage-section__map', { translucent: geozone.deleting })}>
      <Map
        attributionControl={false}
        center={{ lat: position[0], lng: position[1] }}
        zoom={10}
        bounds={points.length > 2 ? points : undefined}
        zoomControl={false}
        style={{ height: '100%', width: '100%'}}
        dragging={false}
        doubleClickZoom={false}
        scrollWheelZoom={false}
      >
        <TileLayer detectRetina url={tileUrl} />
        <Polygon positions={points} />
      </Map>
    </div>
    {geozone.deleting ? <span className="spinner" style={{ top: 70 }} /> : null}
  </div>);
},
);

GeozoneItem.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onActivate: PropTypes.func.isRequired,
  geozone: PropTypes.shape({
    name: PropTypes.string,
    wkt: PropTypes.string,
    isEnabled: PropTypes.bool,
    deleting: PropTypes.bool,
  }).isRequired,
};

GeozoneItem.WrappedComponent.propTypes = {
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/Geozones/GeozoneItem.js